import Vue from 'vue';
import vuescroll from 'vue-scroll';

Vue.use(vuescroll, { debounce: 600 });